module.exports = __webpack_public_path__ + "img/binding_pc_tab_06.491e1069.png";